(() => {
  const selector = '[data-kosbling-hero-carousel]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class KosblingHeroCarousel {
    constructor(root) {
      this.root = root;
      this.slides = [...root.querySelectorAll('[data-kosbling-hero-slide]')];
      this.dots = [...root.querySelectorAll('[data-kosbling-hero-dot]')];
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.interval = Math.max(3000, Number(root.dataset.interval) || 5000);
      this.autoplay = root.dataset.autoplay === 'true';
      this.timer = null;
      this.paused = false;

      if (this.slides.length < 2) return;

      root.querySelector('[data-kosbling-hero-previous]')?.addEventListener('click', () => this.go(this.index - 1, true));
      root.querySelector('[data-kosbling-hero-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.slideIndex), true)));

      root.addEventListener('pointerenter', () => this.pause());
      root.addEventListener('pointerleave', () => this.resume());
      root.addEventListener('focusin', () => this.pause());
      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) this.resume();
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.resume();
      });
      reducedMotion.addEventListener?.('change', () => this.resume());

      this.go(this.index, false);
      this.resume();
    }

    go(nextIndex, userInitiated = false) {
      this.index = (nextIndex + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, index) => {
        const active = index === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
      if (userInitiated) this.restart();
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    pause() {
      this.paused = true;
      this.stop();
    }

    resume() {
      this.paused = false;
      this.stop();
      if (!this.autoplay || reducedMotion.matches || document.hidden) return;
      this.timer = window.setInterval(() => this.go(this.index + 1), this.interval);
    }

    restart() {
      if (!this.paused) this.resume();
    }

    selectBlock(blockId) {
      const index = this.slides.findIndex((slide) => slide.dataset.blockId === blockId);
      if (index >= 0) {
        this.go(index, true);
        this.pause();
      }
    }
  }

  const instances = new WeakMap();
  const initialize = (scope = document) => {
    const roots = scope.matches?.(selector) ? [scope] : [...scope.querySelectorAll(selector)];
    roots.forEach((root) => {
      if (!instances.has(root)) instances.set(root, new KosblingHeroCarousel(root));
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest(selector);
    instances.get(root)?.selectBlock(event.detail.blockId);
  });
})();
